/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TeamAuditResponse } from '../models/TeamAuditResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TeamAuditService {
    /**
     * Get Team Audit Log
     * @param teamId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getTeamAuditLogTeamAuditTeamTeamIdGet(
        teamId: number,
    ): CancelablePromise<(TeamAuditResponse | null)> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/team_audit/team/{team_id}',
            path: {
                'team_id': teamId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Undo Team Patch
     * @param teamId
     * @param patchId
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static undoTeamPatchTeamAuditTeamTeamIdPatchPatchIdPost(
        teamId: number,
        patchId: string,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/team_audit/team/{team_id}/patch/{patch_id}',
            path: {
                'team_id': teamId,
                'patch_id': patchId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
